import SlsAlcadaClient from '@/api/Cadastros/ApoioVendas/sls-alcada.client';

import { ErrorMessage } from '@/libs/Error';

export default class SLSAlcadaService {
  constructor() {
    this.client = new SlsAlcadaClient();
    this.error = new ErrorMessage();
  }

  async index(queries) {
    try {
      const { data } = await this.client.index(queries);
      return data;
    } catch (error) {
      this.error.message(error, 'Erro ao listar os tipo pedido');
    }
  }

  async store(data) {
    try {
      const { data: response } = await this.client.store(data);
      return response;
    } catch (error) {
      this.error.message(error, 'Erro ao criar Alcada');
    }
  }

  async show(id) {
    try {
      const { data } = await this.client.show(id);
      return data;
    } catch (error) {
      this.error.message(error, 'Erro ao buscar Alcada');
    }
  }

  async update(id, data) {
    try {
      const { data: response } = await this.client.update(id, data);
      return response;
    } catch (error) {
      this.error.message(error, 'Erro ao atualizar Alcada');
    }
  }

  async destroy(id) {
    try {
      const { data: response } = await this.client.destroy(id);
      return response;
    } catch (error) {
      this.error.message(error, 'Erro ao deletar Alcada');
    }
  }
}
